require("./personalDataEditView.scss");

// @vendor
const React = require("react");
const { connect } = require("react-redux");
const PropTypes = require("prop-types");
const { withRouter } = require('react-router-dom');
const classnames = require("classnames");

// @actions
const profile = require("actions/profile");
const profileEditorActions = require("actions/profileEditor");

// @core
const { formatText, FormattedText } = require("core/i18n").i18n;

// @utilities
const DateHelper = require("utilities/dateHelper");

// @components
const OKHeaderLanding = require("components/commons/OKHeaderLanding/OKHeaderLanding");
const { CallMeBack } = require("components/callMeBack/callMeBack");
const ErrorStep = require("components/myProfile/myProfileEditor/ErrorStep");
const SuccessStepFatca = require("components/myProfile/myProfileEditor/SuccessStepFatca");
const OKSelect = require("components/commons/OKSelect/OKSelect");
const OKInformativeList = require("components/rebrand/OKInformativeList/OKInformativeList");
const TaxAdditionalCountryForm = require("components/myProfile/taxAdditionalCountryList/taxAdditionalCountryForm");
const PreLeaveModalComponent = require("components/preLeaveModalComponent/preLeaveModalComponent");
const ConfirmStep = require("components/myProfile/myProfileEditor/ConfirmStep");
const {
    CommercialAds
} = require("components/commons/commercialAds/commercialAds");
const Wizard = require("components/commons/wizard/wizard");
const WizardStep = require("components/commons/wizardStep/wizardStep");

// @commons
const { OKMessage } = require("commonsComponents/OKMessage");
const { InputSafe } = require("commonsComponents/inputSafe");
const { OKInput } = require("commonsComponents/OKInput");
const { RadioButtonGroup } = require("commonsComponents/radioButtonGroup");
const { RadioButton } = require("commonsComponents/radioButton");
const { OKTextArea } = require("commonsComponents/OKTextArea");
const { OKCover } = require("commonsComponents/OKCover");

// @routes
const {
    isValidDocumentNumberOfType
} = require("routes/contractsView/utilities/inputsValidationHelper");

// @constants
const { DATE_FORMAT_DAY_MONTH_YEAR } = require("constants/index");
const { DOCUMENT_TYPE_NIE, DOCUMENT_TYPE_NIF } = require("constants/index");
const {
    PROFILE_EDIT_FORMS: { NEWADDRESS }
} = require("constants/myProfileEditor");
const { PREFIX_SPANISH_ISIN_CODE } = require("constants/index");
const { NON_NUMERIC_REGEXP, POSTAL_CODE_REGEX } = require("constants/index");
const { countryOptions } = require("constants/countries");
const { typesOfRoadsOptions } = require("constants/typeOfRoads");
const PROVINCES = require("constants/provinces");
const PROVINCES_OPTIONS = Object.getOwnPropertyNames(PROVINCES).map(
    property => ({
        value: property,
        label: PROVINCES[property]
    })
);
const PROVINCES_OPTIONS_ORDERED = PROVINCES_OPTIONS.sort((a, b) =>
    a.label.localeCompare(b.label)
);
const NIFNIE = {
    NIF: "N",
    NIE: "C",
    Pasaporte: "P",
    Otros: "I"
};
const NIFNIE_OPTIONS = Object.getOwnPropertyNames(NIFNIE).map(property => ({
    value: NIFNIE[property],
    label: formatText(`profile-personalData${property}`)
}));

class PersonalDataEditView extends React.Component {
    constructor(props) {
        super(props);

        this.handleCancel = this.handleCancel.bind(this);
        this.handleFinish = this.handleFinish.bind(this);
        this.isReady = this.isReady.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleDeleteCountry = this.handleDeleteCountry.bind(this);
        this.handleSaveCountry = this.handleSaveCountry.bind(this);
        this.buildForm = this.buildForm.bind(this);
        this.buildEditorBody = this.buildEditorBody.bind(this);
        this.buildPersonalData = this.buildPersonalData.bind(this);
        this.buildFiscalData = this.buildFiscalData.bind(this);
        this.buildResidenceData = this.buildResidenceData.bind(this);
        this.buildMoreFiscalResidences = this.buildMoreFiscalResidences.bind(
            this
        );
        this.handleRadioButtonChange = this.handleRadioButtonChange.bind(this);
    }

    componentDidMount() {
        const { setEditMode, immProfile, initStep } = this.props;

        initStep(immProfile.toJS());
        setEditMode(NEWADDRESS);
    }

    componentWillUnmount() {
        this.props.reset();
    }

    handleCancel() {
        this.props.history.push("/myprofile/edit");
    }

    handleFinish() {
        const { postAddressNewChange } = this.props;
        postAddressNewChange();
    }

    isReady() {
        return false;
    }

    maskContent(content) {
        const cleanContent = content.replace(/-/g, "");
        return `+${cleanContent.substr(0, 2)} ${cleanContent.substr(
            2,
            1
        )}** **${cleanContent.substr(7, 1)} ${cleanContent.substr(8)}`;
    }

    handleDeleteCountry(index) {
        this.props.deleteAdditionalCountries(index);
    }

    handleSaveCountry(index, data) {
        this.props.updateAdditionalCountries(index, data);
    }

    handleRadioButtonChange(id, value) {
        this.props.actionChangeValue({
            [id]: value,
            [id + "Blur"]: false
        });
    }

    handleInputChange(event) {
        const { name } = event.target;
        let { value } = event.target;

        switch (name) {
            case "postalCode":
            case "numberStreet":
                value = value.replace(NON_NUMERIC_REGEXP, "").trim();
                break;
        }

        this.props.actionChangeValue({
            [name]: value,
            [name + "Blur"]: false
        });
    }

    handleSelectChange(event, prop) {
        const value = event.value || "";

        this.props.actionChangeValue({
            [prop]: value,
            [prop + "Blur"]: false
        });
    }

    buildPersonalData() {
        const nameLabel = formatText("profile-name");
        const documentType = formatText("profile-documentType");
        const documentNumber = formatText("profile-documentNumber");

        const { immProfile } = this.props;
        const name =
            immProfile.get("nombreCliente") +
            immProfile.get("apellidoUno").get("apellido") +
            immProfile.get("apellidoDos").get("apellido");
        return (
            <div>
                <h4 className="edit-form-step__title">
                    {formatText(`profileEditForm-personalDataTitle`)}
                </h4>
                <div className="row">
                    <div className="edit-form-step__input edit-form-step__input--margin-modifier col-xs-12">
                        <OKInput
                            disabled={true}
                            label={nameLabel}
                            matchPos="start"
                            matchProp="label"
                            value={name.replace(/\s\s+/g, " ")}
                        />
                    </div>
                    <div className="edit-form-step__input edit-form-step__input--margin-modifier col-xs-6">
                        <OKSelect
                            clearable={false}
                            label={documentType}
                            matchPos="start"
                            matchProp="label"
                            disabled={true}
                            options={NIFNIE_OPTIONS}
                            value={immProfile
                                .get("documentoIdentificacion")
                                .get("tipodocumpersonacorp")}
                        />
                    </div>
                    <div className="edit-form-step__input edit-form-step__input--margin-modifier col-xs-6">
                        <OKInput
                            disabled={true}
                            label={documentNumber}
                            matchPos="start"
                            matchProp="label"
                            value={immProfile
                                .get("documentoIdentificacion")
                                .get("codigodocumpersonacorp")}
                        />
                    </div>
                </div>
            </div>
        );
    }

    buildResidenceData() {
        const residenceCountry = formatText("profile-residenceCountry");
        const equalsCountryError = formatText("profile-equalsCountry");
        const selectNotFound = formatText("profile-selectNotFound");
        const selectPlaceholder = formatText("profile-selectPlaceholder");
        const tinError = formatText("profile-tinError");
        const nifNieError = formatText("profile-nifNieError");

        const { immProfileEditor, immProfile } = this.props;
        const immStep = immProfileEditor.getIn(["steps", 0]);
        const residenceCountryErrorState =
            immStep.get("residenceCountryBlur") &&
            (!immStep.get("residenceCountry") ||
                (immStep.get("residenceCountry") &&
                    (immStep.get("residenceCountry").trim() === "" ||
                        immStep.get("residenceCountry").trim() !==
                        immStep.get("country").trim())));

        const tinErrorState =
            immStep.get("residenceTinBlur") &&
            immStep.get("textAreaTinBlur") &&
            (!immStep.get("residenceTin") ||
                (immStep.get("residenceTin") &&
                    immStep.get("residenceTin").trim() === "")) &&
            (!immStep.get("textAreaTin") ||
                (immStep.get("textAreaTin") &&
                    immStep.get("textAreaTin").trim() === ""));

        const nifNieErrorState =
            immStep.get("nifNieBlur") &&
            immStep.get("residenceCountry") === PREFIX_SPANISH_ISIN_CODE &&
            immProfile.get("paisResidencia") !== PREFIX_SPANISH_ISIN_CODE &&
            (!immStep.get("nifNie") ||
                (immStep.get("nifNie") &&
                    !isValidDocumentNumberOfType(
                        immStep.get("nifNie"),
                        DOCUMENT_TYPE_NIE
                    ) &&
                    !isValidDocumentNumberOfType(
                        immStep.get("nifNie"),
                        DOCUMENT_TYPE_NIF
                    )));

        return (
            <div>
                <div className="row">
                    <div className="edit-form-step__input col-xs-12">
                        <OKSelect
                            clearable={false}
                            label={residenceCountry}
                            matchPos="start"
                            matchProp="label"
                            noResultsText={selectNotFound}
                            onChange={event =>
                                this.handleSelectChange(
                                    event,
                                    "residenceCountry"
                                )
                            }
                            options={countryOptions()}
                            placeholder={selectPlaceholder}
                            value={immStep.get("residenceCountry")}
                            errorState={residenceCountryErrorState}
                            errorMessage={equalsCountryError}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="edit-form-step__input col-xs-6">
                        {immStep.get("residenceCountry") &&
                            immStep.get("residenceCountry") !==
                            PREFIX_SPANISH_ISIN_CODE && (
                                <InputSafe
                                    label={formatText("profile-tinInputLabel")}
                                    name="residenceTin"
                                    type="text"
                                    value={immStep.get("residenceTin")}
                                    onChange={this.handleInputChange}
                                    errorState={tinErrorState}
                                    errorMessage={tinError}
                                />
                            )}
                        {immStep.get("residenceCountry") &&
                            immStep.get("residenceCountry") ==
                            PREFIX_SPANISH_ISIN_CODE &&
                            immProfile.get("paisResidencia") !==
                            PREFIX_SPANISH_ISIN_CODE && (
                                <InputSafe
                                    label={formatText(
                                        "profile-nienifInputLabel"
                                    )}
                                    name="nifNie"
                                    type="text"
                                    value={immStep.get("nifNie")}
                                    onChange={this.handleInputChange}
                                    errorState={nifNieErrorState}
                                    errorMessage={nifNieError}
                                />
                            )}
                    </div>
                </div>
                <div className="row">
                    <div className="edit-form-step__input edit-form-step__input--no-label col-xs-9">
                        {immStep.get("residenceCountry") &&
                            immStep.get("residenceCountry") !==
                            PREFIX_SPANISH_ISIN_CODE && (
                                <OKTextArea
                                    customClass="edit-form-step__textarea"
                                    onChange={this.handleInputChange}
                                    name="textAreaTin"
                                    value={immStep.get("textAreaTin")}
                                    placeholder={formatText(
                                        "profile-noTinPlaceholder"
                                    )}
                                    errorState={tinErrorState}
                                    errorMessage={tinError}
                                />
                            )}
                    </div>
                </div>
            </div>
        );
    }

    buildMoreFiscalResidences() {
        const { immProfileEditor } = this.props;
        const immStep = immProfileEditor.getIn(["steps", 0]);
        const immCountries = immStep.get("listPaisesTributacionAdic");

        const moreFiscalResidencesErrorState =
            immStep.get("moreFiscalResidencesBlur") &&
            (!immStep.get("moreFiscalResidences") ||
                immStep.get("moreFiscalResidences") === "");

        const residenceLabel =
            immStep.get("residenceCountry") !== PREFIX_SPANISH_ISIN_CODE
                ? formatText("profile-fiscalResidenceOtherCountries")
                : formatText("profile-fiscalResidenceOtherNotSpain");

        const moreFiscalResidencesErrorMessage = formatText(
            "profile-moreFiscalResidencesErrorMessage"
        );
        const disableOptions = immStep.get("moreFiscalResidences") === "N";

        const renderTaxAdditionalCountryForm = () => {
            let countryForm;
            if (immStep.get("moreFiscalResidences") === "S") {
                countryForm = (
                    <TaxAdditionalCountryForm
                        immCountries={immCountries}
                        onDeleteCountry={this.handleDeleteCountry}
                        onSaveCountry={this.handleSaveCountry}
                        AddingFlag={false}
                        addNoTin={true}
                        disableAdd={disableOptions}
                        disableEdit={disableOptions}
                        disableRemove={disableOptions}
                    />
                );
            }
            return countryForm;
        };

        const renderMessage = () => {
            if (immStep.get("moreFiscalResidences") === "N")
                return immCountries.size ? (
                    <div className="edit-form-step__warning-wrapper">
                        <OKMessage
                            id="profile-editor-message-warning"
                            type="warning"
                        >
                            <FormattedText value="profile-deleteMoreFiscalCountries" />
                        </OKMessage>
                    </div>
                ) : null;

            if (immStep.get("moreFiscalResidences") === "S")
                return immCountries.size ? (
                    <div className="edit-form-step__warning-wrapper">
                        <OKMessage
                            id="profile-editor-message-warning"
                            type="important"
                        >
                            <FormattedText value="profile-reviewMoreFiscalCountries" />
                        </OKMessage>
                    </div>
                ) : (
                        <div className="edit-form-step__error-wrapper">
                            <OKMessage
                                id="profile-editor-message-error"
                                type="warning"
                            >
                                <FormattedText value="profile-completeMoreFiscalCountries" />
                            </OKMessage>
                        </div>
                    );
        };

        return (
            <OKInformativeList
                columns={1}
                title="profile-taxInformation_CountriesAdditionalTributationTitle"
            >
                {immStep.get("residenceCountry") && (
                    <RadioButtonGroup
                        name="moreFiscalResidences"
                        idPrefix="moreFiscalResidences"
                        selectedValue={immStep.get("moreFiscalResidences")}
                        onChange={value =>
                            this.handleRadioButtonChange(
                                "moreFiscalResidences",
                                value
                            )
                        }
                        label={residenceLabel}
                        isHorizontal={true}
                        errorState={moreFiscalResidencesErrorState}
                        errorMessage={moreFiscalResidencesErrorMessage}
                    >
                        <RadioButton
                            label={formatText("profile-fiscalResidenceYes")}
                            value={"S"}
                        />
                        <RadioButton
                            label={formatText("profile-fiscalResidenceNo")}
                            value={"N"}
                        />
                    </RadioButtonGroup>
                )}
                {renderMessage()}
                {renderTaxAdditionalCountryForm()}
            </OKInformativeList>
        );
    }

    buildFiscalData() {
        const birthCountry = formatText(
            "profile-taxInformation_birthCountryFull"
        );
        const selectNotFound = formatText("profile-selectNotFound");
        const selectPlaceholder = formatText("profile-selectPlaceholder");
        const birthLocality = formatText(
            "profile-taxInformation_birthLocality"
        );
        const birthProvince = formatText(
            "profile-taxInformation_birthProvince"
        );
        const birthDay = formatText("profile-birthDay");

        const { immProfileEditor } = this.props;
        const immStep = immProfileEditor.getIn(["steps", 0]);
        const provinceClass = classnames("edit-form-step__input col-xs-4", {
            "edit-form-step--hide":
                immStep.get("birthCountry") &&
                immStep.get("birthCountry").trim() !== PREFIX_SPANISH_ISIN_CODE
        });

        return (
            <div>
                <h4 className="edit-form-step__title">
                    {formatText(`profileEditForm-fiscalDataTitle`)}
                </h4>
                <div>
                    <div className="row">
                        <div className="edit-form-step__input col-xs-4">
                            <InputSafe
                                label={birthDay}
                                name="birthDay"
                                disabled={true}
                                type="text"
                                value={
                                    immStep.get("birthDay") !== ""
                                        ? DateHelper.formatDate(
                                            immStep.get("birthDay"),
                                            DATE_FORMAT_DAY_MONTH_YEAR
                                        )
                                        : ""
                                }
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="edit-form-step__input edit-form-step__input--margin-modifier col-xs-4">
                            <OKSelect
                                clearable={false}
                                disabled={true}
                                label={birthCountry}
                                matchPos="start"
                                matchProp="label"
                                options={countryOptions()}
                                placeholder={selectPlaceholder}
                                value={immStep.get("birthCountry")}
                            />
                        </div>
                        <div className={provinceClass}>
                            <OKSelect
                                clearable={false}
                                disabled={true}
                                label={birthProvince}
                                matchPos="start"
                                matchProp="label"
                                noResultsText={selectNotFound}
                                options={PROVINCES_OPTIONS_ORDERED}
                                placeholder={selectPlaceholder}
                                value={immStep.get("birthProvince")}
                            />
                        </div>
                        <div className="edit-form-step__input col-xs-4">
                            <InputSafe
                                label={birthLocality}
                                disabled={true}
                                name="birthSquare"
                                type="text"
                                value={immStep.get("birthSquare")}
                            />
                        </div>
                    </div>
                    {this.buildResidenceData()}
                    <div className="profile-edit-view__wrapper-tax-information">
                        {this.buildMoreFiscalResidences()}
                    </div>
                </div>
            </div>
        );
    }

    buildForm() {
        const addressError = formatText("profile-incompleteAddress");
        const addressName = formatText("profile-addressName");
        const addressNumber = formatText("profile-addressNumber");
        const addressNumberError = formatText(
            "profile-incompleteAddressNumber"
        );
        const addressType = formatText("profile-addressType");
        const addressCountry = formatText("profile-addressCountry");
        const city = formatText("profile-city");
        const dropdownError = formatText("profile-incompleteDropdown");
        const localityError = formatText("profile-incompleteCity");
        const postalCode = formatText("profile-postCode");
        const postalCodeEmpty = formatText("profile-incompletePostalCode");
        const postalCodeMismatch = formatText("profile-mismatchedPostalCode");
        const province = formatText("profile-province");
        const restOfAddress = formatText("profile-restOfAddress");
        const restOfAddressAndPostalCode = formatText(
            "profile-restOfAddressAndPostalCode"
        );
        const selectNotFound = formatText("profile-selectNotFound");
        const selectPlaceholder = formatText("profile-selectPlaceholder");

        const { immProfileEditor } = this.props;
        const immStep = immProfileEditor.getIn(["steps", 0]);
        const localityErrorState =
            immStep.get("localityBlur") && immStep.get("locality") === "";
        const numberStreetErrorState =
            immStep.get("numberStreetBlur") &&
            immStep.get("numberStreet") === "";
        const postalCodeErrorState =
            immStep.get("postalCodeBlur") &&
            (!immStep.get("postalCode").startsWith(immStep.get("province")) ||
                !POSTAL_CODE_REGEX.test(immStep.get("postalCode")));
        const postalCodeErrorMessage =
            postalCodeErrorState &&
            (POSTAL_CODE_REGEX.test(immStep.get("postalCode"))
                ? postalCodeMismatch
                : postalCodeEmpty);
        const provinceErrorState =
            immStep.get("provinceBlur") && immStep.get("province") === "";
        const streetNameErrorState =
            immStep.get("streetNameBlur") && immStep.get("streetName") === "";
        const typeOfRoadsErrorState =
            immStep.get("typeOfRoadsBlur") && immStep.get("typeOfRoads") === "";
        const countryErrorState =
            immStep.get("countryBlur") &&
            (!immStep.get("country") || immStep.get("country") === "");
        const fieldsVisible =
            immStep.get("country") != "" &&
            immStep.get("country") == PREFIX_SPANISH_ISIN_CODE;
        const roadsOptions = typesOfRoadsOptions();
        if (!fieldsVisible) {
            this.handleSelectChange("", "province");
            this.handleSelectChange("", "numberStreet");
            this.handleSelectChange("", "postalCode");
            this.handleSelectChange("", "typeOfRoads");
        }
        return (
            <div>
                <div className="row">
                    <div className="col-xs-12 edit-form-step__input">
                        <OKSelect
                            clearable={false}
                            label={addressCountry}
                            matchPos="start"
                            matchProp="label"
                            noResultsText={selectNotFound}
                            options={countryOptions()}
                            placeholder={selectPlaceholder}
                            value={immStep.get("country")}
                            onChange={event =>
                                this.handleSelectChange(event, "country")
                            }
                            errorState={countryErrorState}
                            errorMessage={dropdownError}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-6 edit-form-step__input">
                        {fieldsVisible ? (
                            <OKSelect
                                clearable={false}
                                label={addressType}
                                matchPos="start"
                                matchProp="label"
                                noResultsText={selectNotFound}
                                onChange={event =>
                                    this.handleSelectChange(
                                        event,
                                        "typeOfRoads"
                                    )
                                }
                                options={roadsOptions}
                                placeholder={selectPlaceholder}
                                value={immStep.get("typeOfRoads")}
                                errorState={typeOfRoadsErrorState}
                                errorMessage={dropdownError}
                            />
                        ) : (
                                <InputSafe
                                    label={city}
                                    maxLength={50}
                                    name="locality"
                                    onBlur={this.handleBlur}
                                    onChange={this.handleInputChange}
                                    type="text"
                                    value={immStep.get("locality")}
                                    errorState={localityErrorState}
                                    errorMessage={localityError}
                                />
                            )}
                    </div>
                    <div className="col-xs-6 edit-form-step__input">
                        <InputSafe
                            label={addressName}
                            maxLength={50}
                            name="streetName"
                            onBlur={this.handleBlur}
                            onChange={this.handleInputChange}
                            type="text"
                            value={immStep.get("streetName")}
                            errorState={streetNameErrorState}
                            errorMessage={addressError}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-6 edit-form-step__input">
                        {fieldsVisible ? (
                            <InputSafe
                                label={addressNumber}
                                maxLength={5}
                                name="numberStreet"
                                onBlur={this.handleBlur}
                                onChange={this.handleInputChange}
                                type="text"
                                value={immStep.get("numberStreet")}
                                errorState={numberStreetErrorState}
                                errorMessage={addressNumberError}
                            />
                        ) : null}
                    </div>
                    <div className="col-xs-6 edit-form-step__input">
                        <InputSafe
                            label={
                                immStep.get("country") ==
                                    PREFIX_SPANISH_ISIN_CODE
                                    ? restOfAddress
                                    : restOfAddressAndPostalCode
                            }
                            maxLength={50}
                            name="restOfAddress"
                            onBlur={this.handleBlur}
                            onChange={this.handleInputChange}
                            type="text"
                            value={immStep.get("restOfAddress")}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-4 edit-form-step__input">
                        {fieldsVisible && (
                            <InputSafe
                                label={postalCode}
                                maxLength={5}
                                name="postalCode"
                                onBlur={this.handleBlur}
                                onChange={this.handleInputChange}
                                type="text"
                                value={immStep.get("postalCode")}
                                errorState={postalCodeErrorState}
                                errorMessage={postalCodeErrorMessage}
                            />
                        )}
                    </div>
                    <div className="col-xs-4 edit-form-step__input">
                        {fieldsVisible && (
                            <InputSafe
                                label={city}
                                maxLength={50}
                                name="locality"
                                onBlur={this.handleBlur}
                                onChange={this.handleInputChange}
                                type="text"
                                value={immStep.get("locality")}
                                errorState={localityErrorState}
                                errorMessage={localityError}
                            />
                        )}
                    </div>
                    <div className="col-xs-4 edit-form-step__input">
                        {fieldsVisible && (
                            <OKSelect
                                clearable={false}
                                label={province}
                                matchPos="start"
                                matchProp="label"
                                noResultsText={selectNotFound}
                                onChange={event =>
                                    this.handleSelectChange(event, "province")
                                }
                                options={PROVINCES_OPTIONS_ORDERED}
                                placeholder={selectPlaceholder}
                                value={immStep.get("province")}
                                errorState={provinceErrorState}
                                errorMessage={dropdownError}
                            />
                        )}
                    </div>
                </div>
            </div>
        );
    }

    buildEditor() {
        const {
            immProfileEditor,
            setVisibleStep,
            validateStep,
            immProfile,
            setWillCancel
        } = this.props;

        const actions = {
            validateStep: step => validateStep(step, immProfile),
            setVisibleStep,
            setWillCancel,
            finish: this.handleFinish,
            cancel: this.handleCancel
        };

        const immSteps = immProfileEditor.get("steps");
        const commercialAd = __CONTACT_CENTER__ || (
            <CommercialAds path="edit" type="banner-a" />
        );

        return (
            <div>
                <div className="profile-edit-view row grid-view--content-position-positive">
                    <div className="col-xs-12 col-md-8">
                        <div className="row">
                            <div className="col-md-12 grid-view--fix-cell-separation">
                                <div>
                                    <PreLeaveModalComponent
                                        confirmationMessage={formatText(
                                            "wizard-redirectConfirmationMessage"
                                        )}
                                        confirmationTitle={formatText(
                                            "wizard-redirectConfirmationTitle"
                                        )}
                                        acceptText={formatText(
                                            "wizard-redirectConfirmationAcceptButton"
                                        )}
                                        cancelText={formatText(
                                            "wizard-redirectConfirmationCancelButton"
                                        )}
                                        isReady={this.isReady}
                                    />
                                    <Wizard
                                        actions={actions}
                                        immSteps={immSteps}
                                        visibleStep={immProfileEditor.get(
                                            "visibleStep"
                                        )}
                                        stepsAmount={immSteps.size}
                                    >
                                        <WizardStep
                                            cancelButton={true}
                                            position="first"
                                        >
                                            <div className="edit-form-step">
                                                <div className="edit-form-step__informative-wrapper">
                                                    <OKMessage
                                                        id="profile-editor-message-informative"
                                                        type="informative"
                                                    >
                                                        <FormattedText value="profile-informativeHeader" />
                                                    </OKMessage>
                                                </div>
                                                {this.buildPersonalData()}
                                                <h4 className="edit-form-step__title">
                                                    <FormattedText value="profileEditForm-addressFatcaTitle" />
                                                </h4>
                                                <div className="edit-form-step__address-informative-wrapper">
                                                    <OKMessage
                                                        id="profile-editor-message-informative"
                                                        type="informative"
                                                    >
                                                        <FormattedText value="profile-informativeAddressHeader" />
                                                    </OKMessage>
                                                </div>
                                                {this.buildForm()}
                                                {this.buildFiscalData()}
                                            </div>
                                        </WizardStep>
                                        <WizardStep
                                            addLoadingBehaviour={true}
                                            cancelButton={true}
                                            position="last"
                                            immFinalButton="profile-modifyButton"
                                        >
                                            <ConfirmStep
                                                immProfile={immProfile}
                                                immProfileEditor={
                                                    immProfileEditor
                                                }
                                            />
                                        </WizardStep>
                                    </Wizard>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xs-12 col-md-4">
                        <div className="row">
                            <div className="col-xs-6 col-md-12 grid-view--fix-cell-separation">
                                <CallMeBack
                                    hasEntrance={false}
                                    pageTitle={formatText(
                                        "profile-titleHeader"
                                    )}
                                />
                            </div>
                            <div className="col-xs-12 grid-view--fix-cell-separation">
                                {commercialAd}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    buildEditorBody() {
        const { immProfileEditor } = this.props;
        const isFetching = immProfileEditor.get("isFetching");
        const submitSuccessful = immProfileEditor.get("submitSuccessful");
        const hasError = immProfileEditor.get("errorReceived") !== "";
        let bodyContent = this.buildEditor();

        if (!isFetching && submitSuccessful) {
            bodyContent = (
                <SuccessStepFatca onConfirmLeave={this.handleCancel} />
            );
        } else if (hasError) {
            bodyContent = <ErrorStep onConfirmLeave={this.handleCancel} />;
        }

        return bodyContent;
    }

    render() {
        const titleHeader = formatText("profile-titleHeader");
        const editorBody = this.buildEditorBody();
        return (
            <div>
                <div className="container-fluid">
                    <div className="row">
                        <OKCover
                            size="small"
                            section="pg"
                            customClass="col-xs-12"
                        >
                            <OKHeaderLanding title={titleHeader} />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">{editorBody}</div>
                </div>
            </div>
        );
    }
}

PersonalDataEditView.propTypes = {
    actionChangeValue: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immProfileEditor: PropTypes.object.isRequired,
    postAddressNewChange: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    removeDocumentListError: PropTypes.func,
    setEditMode: PropTypes.func.isRequired,
    setUserAlias: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    updateAdditionalCountries: PropTypes.func.isRequired,
    deleteAdditionalCountries: PropTypes.func.isRequired,
    initStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired
};

module.exports.constructor = PersonalDataEditView;
module.exports.PersonalDataEditView = connect(
    state => ({
        immProfileEditor: state.profileEditor.merge({ editMode: NEWADDRESS }),
        immProfile: state.profile
    }),
    {
        actionChangeValue: profileEditorActions.actionChangeValue,
        postAddressNewChange: profileEditorActions.postAddressNewChange,
        reset: profileEditorActions.reset,
        setEditMode: profileEditorActions.setEditMode,
        setUserAlias: profile.setUserAlias,
        setVisibleStep: profileEditorActions.setVisibleStep,
        validateStep: profileEditorActions.validateStep,
        updateAdditionalCountries:
            profileEditorActions.updateAdditionalCountries,
        deleteAdditionalCountries:
            profileEditorActions.deleteAdditionalCountries,
        initStep: profileEditorActions.initStep,
        setWillCancel: profileEditorActions.setWillCancel
    }
)(withRouter(PersonalDataEditView));
